import { createTheme, darken, lighten } from "@mui/material/styles";
import "@fontsource/jost/400.css";
import "@fontsource-variable/inter";
import "@fontsource/poppins/200.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource-variable/lexend-deca";

const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: "Inter, sans-serif",
    },
  },
});

const themeLight = createTheme(theme, {
  palette: {
    mode: "light",
    primary: {
      main: "#13319a",
      light: "#4c91f7",
      lighter: "#ecf4ff",
      contrastText: "#fff",
    },
    secondary: {
      main: "#e50b71",
      dark: darken("#e50b71", 0.2),
      light: lighten("#e50b71", 0.9),
      contrastText: "#fff",
    },
    text: {
      primary: "#131313",
      helper: "#555555",
    },
    purple: {
      main: "#DDD5FF",
      light: "#F9E8FF",
      dark: "#520c6b",
      contrastText: "#131313",
    },
    yellow: {
      main: "#dfb400",
      light: "#ffffb7",
      contrastText: "#131313",
    },
    black: {
      main: "#131313",
      light: "#333",
      contrastText: "#fff",
    },
    success: {
      ...theme.palette.success,
      main: "#BCFBC6",
      dark: "#18661e",
      border: "#10BA2B",
      contrastText: "#131313",
    },
    divider: theme.palette.grey[500], // #9e9e9e
    border: theme.palette.grey[300], // #e0e0e0
  },
  typography: {
    fontFamily: "Inter, sans-serif",
    h1: {
      fontFamily: "Poppins, sans-serif",
      fontSize: "32px",
      fontWeight: "400",
    },
    h2: {
      fontFamily: "Poppins, sans-serif",
      fontSize: "24px",
      fontWeight: "400",
    },
    h3: {
      fontFamily: "Poppins, sans-serif",
      fontSize: "20px",
      fontWeight: "500",
    },
    h4: {
      fontSize: "16px",
      fontWeight: "500",
    },
    h5: {
      fontSize: "12px",
      fontWeight: "500",
    },
    h6: {
      fontSize: "11px",
      fontFamily: "Poppins, sans-serif",
    },
    subtitle1: {
      fontWeight: "500",

      [theme.breakpoints.down("sm")]: {
        fontSize: "0.9rem",
      },
    },
    body1: {
      fontSize: "0.875rem", // "0.9375rem",
      fontWeight: "300",
    },
    body2: {
      fontWeight: "300",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "Inter, sans-serif",
          fontWeight: "400",
          fontSize: "15px",
          textTransform: "none",
          borderRadius: "4px",
          padding: "8px 32px",
          boxShadow: "none",
        },
      },
    },
    MuiDialogTitle: {
      root: {
        fontSize: "24px",
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          scrollBehavior: "smooth",
        },
        ".cookie-consent": {
          display: "none",
          position: "fixed",
          bottom: "0",
          left: "0",
          right: "0",
          zIndex: "9999",
          padding: "10px 20px",
          backgroundColor: "#fff",
          width: "100%",
          borderTop: "1px solid #e0e0e0",
          textAlign: "center",
          "& button": {
            borderRadius: "4px",
            borderColor: "transparent",
            cursor: "pointer",
          },

          "&.show": {
            display: "block",
          },
        },
        a: {
          textDecoration: "underline",
          color: "#e50b71",
          "&:hover": {
            textDecoration: "none",
          },
        },
      },
    },
  },
});

export default themeLight;

export const publicTheme = createTheme(themeLight, {
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "2px",
          fontWeight: "400",
          fontSize: "14.5px",
        },
      },
    },
  },
});
